export class InvitationCode {
  id: number;
  invitationCode: string;
  status: number;
  expireDate: any;
  createDate: any;

  constructor(id?: number, invitationCode?: string, status?: number, expireDate?: any, createDate?: any) {
    this.id = id;
    this.invitationCode = invitationCode;
    this.status = status;
    this.expireDate = expireDate;
    this.createDate = createDate;
  }
}

export class InvitationCodeFindParam {
  invitationCode: string;
  status: number;
  page = 1;
  size = 20;

  constructor(invitationCode?: string, status?: number, page?: number, size?: number) {
    this.invitationCode = invitationCode;
    this.status = status;
    this.page = page;
    this.size = size;
  }
}

export class InviteHistory {
  email: string;
  userInviterId: string;
  phoneNumber: string;
  twilioPhone: string;
  countryCode: string;

  constructor(userInviterId: string) {
    this.userInviterId = userInviterId;
  }
}
